import firebase from 'firebase'
import { Link } from 'react-router-dom'
import { userRef } from '../../config'
import React, { Component } from 'react'
import logo from '../../assets/img/login2.png';

export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.handleSignup = this.handleSignup.bind(this)
    this.onEmailChange = this.onEmailChange.bind(this)
    this.onPasswordChange = this.onPasswordChange.bind(this)
    this.onFirstNameChange = this.onFirstNameChange.bind(this)
    this.onLastNameChange = this.onLastNameChange.bind(this)
    this.state = {
      email: '',
      password: '',
      firstName: '',
      lastName: ''
    }
  }

  onEmailChange(e) {
    this.setState({
      email: e.target.value
    })

  }
  onPasswordChange(e) {
    this.setState({
      password: e.target.value
    })

  }
  onFirstNameChange(e) {
    this.setState({
      firstName: e.target.value
    })
  }
  onLastNameChange(e) {
    this.setState({
      lastName: e.target.value
    })
  }
  handleSignup(e) {
    e.preventDefault();
    console.log('handling signup')
    console.log(this.state)
    console.log('got user ref', userRef)
    if(this.state.firstName.length === 0) {
      this.setState({
        error: 'you did not specify a firstName'
      })
      return
    }
    else if(this.state.lastName.length === 0) {
      this.setState({
        error: 'You did not specify a last name'
      })
      return
    }
    else if(this.state.email.length === 0 || !this.state.email.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)) {
      this.setState({
        error: 'a valid email address is required'
      })
      return
    }
    else if(this.state.password.length === 0) {
      this.setState({
        error: 'you did not specify a password'
      })
      return
    }
    firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
    .then(user => {
      let { firstName, lastName } = this.state
      let {uid, email } = user
      let newUser = {
        uid,
        email,
        createdAt: Date.now(),
        firstName,
        lastName,
        userType:'user',
        pendingApproval:true,
        allowableRoutes: {
          calculator:true,
          codebank: true,
          onsalelist: true,
          reports: true,
          research: true,
        },
        accountStatus: 'pending'
      }
      Object.keys(newUser).forEach(k =>
        localStorage.setItem(k, newUser[k])
      )
      localStorage.setItem('loggedIn', true)
      return userRef.child(uid).set(newUser)

    })
    .then(() => {
      return this.props.history.push('PendingApproval')
    })
    .catch(error => {
      this.setState({
        error: error.message
      })
    })



  }
  render() {
    return (
      <div className='login-wrap'>
  			<div className='center-align'>
  				<div className='container'>
  					<div className='logo-login text-center'>
              <img className='img-responsive' src={logo}/>
  					</div>
  					<div className="row flex-row align-center">
  						<div className="col-sm-3 hidden-xs col-md-4">
  							<div className="login-line"></div>
  						</div>
  						<div className="col-sm-6 col-xs-12 col-md-4 login-form">
                        {this.state.error ? <p className='text-danger'> {this.state.error} </p>: null}
  						<form>
  							<div className="form-group">
  								<div className="input-group">
  									<span className="input-group-addon"><i className="icon ion-ios-person-outline"></i></span>
  									<input type="text" className="form-control" onChange={this.onEmailChange} placeholder="EMAIL" />
  								</div>
  							</div>
  							<div className="form-group">
  								<div className="input-group">
  									<span className="input-group-addon">
  										<i className="icon ion-ios-unlocked-outline"></i>
  									</span>
  									<input type="password" autoComplete="off" className="form-control" onChange={this.onPasswordChange} placeholder="PASSWORD" />
  								</div>
  							</div>
                <div className="form-group">
  								<div className="input-group">
  									<span className="input-group-addon"><i className="icon ion-ios-person-outline"></i></span>
  									<input type="text" className="form-control" onChange={this.onFirstNameChange} placeholder="FIRST NAME" />
  								</div>
  							</div>
                <div className="form-group">
  								<div className="input-group">
  									<span className="input-group-addon"><i className="icon ion-ios-person-outline"></i></span>
  									<input type="text" className="form-control" onChange={this.onLastNameChange} placeholder="LAST NAME" />
  								</div>
  							</div>

                <div className="text-center">
  								<button className="btn btn-login btn-primary" onClick={this.handleSignup} type="submit">Signup</button>
  							</div>
  						</form>
  						</div>
  						<div className="col-sm-3 hidden-xs col-md-4">
  							<div className="login-line"></div>
  						</div>
  					</div>
                    <div className="text-center register-col">
						Have an account? <Link to='/login'> Login </Link>
					</div>
  				</div>
  			</div>
  		</div>  )
  }
}



// WEBPACK FOOTER //
// ./src/views/Signup/Signup.js